import CandidateProject, { CandidateProjectProps } from './CandidateProject.container';

export type CandidateProjectType = CandidateProjectProps;

export default CandidateProject;
